import { DynamicDisclosureProvider } from "@umami/components";
import { errorsActions } from "@umami/state";
import { getErrorContext } from "@umami/utils";
import { PostHogProvider } from "posthog-js/react";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { ErrorBoundary } from "react-error-boundary";
import { BrowserRouter } from "react-router-dom";

import "./config";

import { App } from "./components/App";
import { ErrorPage } from "./components/ErrorPage";
import { IS_DEV, POSTHOG_API_KEY, POSTHOG_HOST } from "./env";
import { ReactQueryProvider } from "./providers/ReactQueryProvider";
import { ReduxStore } from "./providers/ReduxStore";
import { UmamiTheme } from "./providers/UmamiTheme";
import { store } from "./utils/store";
import "./utils/hotjar";
import "./utils/sentry";
import "./index.scss";

// TODO: Move to a hook in @umami/state
const logError = (error: Error, info: { componentStack?: string | null }) => {
  const errorContext = { ...getErrorContext(error), stacktrace: String(info.componentStack) };
  store.dispatch(errorsActions.add(errorContext));
};

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <PostHogProvider
      apiKey={POSTHOG_API_KEY}
      options={{
        api_host: POSTHOG_HOST,
        capture_exceptions: true,
        debug: IS_DEV,
        // Ensure no sensitive data is leaked
        disable_session_recording: true,
        autocapture: false,
      }}
    >
      <UmamiTheme>
        <ReduxStore>
          <ErrorBoundary fallback={<ErrorPage />} onError={logError}>
            <ReactQueryProvider>
              <BrowserRouter>
                <DynamicDisclosureProvider>
                  <App />
                </DynamicDisclosureProvider>
              </BrowserRouter>
              {/* Uncomment to use react-query devtools */}
              {/* <ReactQueryDevtools initialIsOpen={true} /> */}
            </ReactQueryProvider>
          </ErrorBoundary>
        </ReduxStore>
      </UmamiTheme>
    </PostHogProvider>
  </StrictMode>
);
